<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Card'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      @if (loaded) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Use cards to group checklist items together for your pro.'" />
        </tidy-row>
        <tidy-card>
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-auto-complete
                [label]="'Card Name'"
                formControlName="name"
                [options]="rooms"
                [form]="form.controls.name"
                [icon]="'assets/svg/information-circle-outline.svg'"
                [isToSearchBetweenOptions]="true"
                [submitted]="submitted"
                [errorMessage]="'Please enter the name of the card.'" />
            </tidy-row>
        </tidy-card>
        <tidy-button
          [text]="'Add Card'"
          [action]="boundAddRoom"
          class="primary" />
      }

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
